import { Box } from '@modusign/design-system';
import { MouseEventHandler } from 'react';

import TextBaseFieldPlaceholder, {
  TextBaseFieldPlaceholderProps,
} from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder';

export interface AddressFieldPlaceholderProps
  extends Omit<TextBaseFieldPlaceholderProps, 'value'> {}

const defaultProps = {
  rootElementSize: null,
  onMouseDown(_event: MouseEventHandler<HTMLDivElement>) {},
};

function AddressFieldPlaceholder(props: AddressFieldPlaceholderProps) {
  return (
    <TextBaseFieldPlaceholder
      {...props}
      value={
        <Box>
          #주소
          <span
            style={{
              color: '#757575',
            }}
          >
            (우편번호·기본·상세)
          </span>
        </Box>
      }
    />
  );
}

AddressFieldPlaceholder.defaultProps = defaultProps;

export default AddressFieldPlaceholder;
